<template>
    <div class="ticket-wrapper" ref="ticketWrapperRef">
        <!-- 未领取占位图 -->
        <img v-if="!ticketData.hasTicket" src="../images/unsign.png" class="ticket-placeholder" alt="" />
        <!-- 门票卡片容器 -->
        <div v-else class="ticket-container">
            <!-- 状态文本 - "未报名" -->
            <div class="status-text">
                {{ statusText }}
            </div>

            <!-- 用户昵称 - "富得流油的富途牛牛" -->
            <div class="user-nickname">
                {{ formattedUserNickname }}
            </div>

            <!-- 时间信息容器 - Frame 2131032421 -->
            <div class="time-info-container">
                <!-- 日期文本 - "2026.3.13-3.14" -->
                <div class="date-text">
                    {{ props.dateText }}
                </div>

                <!-- 时间段文本 - "10:00-18:00" -->
                <div class="time-text">
                    {{ props.timeText }}
                </div>
            </div>
        </div>

        <button v-if="!ticketData.hasTicket" class="claim-button" @click="handleJoin">
            <span class="button-text">免費拎門票</span>
        </button>
        <div v-else class="ticket-button-container">
            <button class="claim-button" @click="() => (state.showVerifyModal = true)">
                <span class="button-text">簽到碼</span>
            </button>
            <template v-if="!hsaChecked">
                <button v-if="hasSessionTicket" class="claim-button" @click="handleShareExpoPage">
                    <span class="button-text">邀好友拎免費門票</span>
                </button>
                <button v-else-if="hasSessionRemain" class="claim-button" @click="handleSession">
                    <span class="button-text">報名投資策略會</span>
                </button>
                <button v-else class="claim-button" @click="handleShareExpoPage">
                    <span class="button-text">邀好友拎免費門票</span>
                </button>
            </template>
        </div>
        <VerifyModal
            v-if="state.showVerifyModal && state.verifyUrl"
            :verify-url="state.verifyUrl"
            :close="() => (state.showVerifyModal = false)"
        />
    </div>
</template>

<script >
import { use as fegoUse } from '@fegobull/webapi';
import { computed, onMounted, ref, watch, reactive } from 'vue-demi';
import VerifyModal from '../components/VerifyModal/index.vue';
import API from '../script/api/index';
const __sfc_main = {};
__sfc_main.props = {
  actSign: {
    type: String,
    default: ''
  },
  module: {
    type: String,
    default: ''
  },
  dateText: {
    type: String,
    default: ''
  },
  timeText: {
    type: String,
    default: ''
  },
  verifyUrl: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const ticketWrapperRef = ref(null);
  const {
    store: {
      variable
    }
  } = require('@futuweb/fego-render');
  const {
    throttle
  } = require('@futuweb/fego-bridge');
  const state = reactive({
    showVerifyModal: false,
    verifyUrl: ''
  });
  const props = __props;
  const hsaChecked = ref(false);
  const {
    useToast
  } = fegoUse;
  const toast = useToast();
  const {
    toLogin,
    isLogin
  } = require('./utils');
  const emit = __ctx.emit;

  // 用户数据
  const userData = ref({
    uid: window._params.uid
  });

  // 门票数据
  const ticketData = ref({
    id: null,
    act_sign: '',
    uid: 0,
    status: 0,
    verify_time: null,
    create_time: null,
    update_time: null,
    hasTicket: false,
    nick: '',
    avatar: ''
  });

  // 显示数据
  const statusText = ref('未报名');
  const userNickname = ref('富得流油的富途牛牛');
  const buttonText = ref('免費拎門票');

  // 格式化后的用户昵称 - 超过9个字符则截断并添加省略号
  const formattedUserNickname = computed(() => {
    const nickname = userNickname.value;
    if (nickname.length > 8) {
      return nickname.substring(0, 8) + '...';
    }
    return nickname;
  });
  const hasSessionTicket = computed(() => {
    return variable.data.hasSessionTicket;
  });
  const hasSessionRemain = computed(() => {
    return variable.data.hasSessionRemain;
  });

  // 监听 sessionTimeText 变化，实时更新状态文本
  watch(() => variable.data.sessionTimeText, newValue => {
    if (newValue) {
      statusText.value = newValue;
    }
  }, {
    immediate: true
  });

  /**
   * 初始化 - 获取门票详情
   */
  const init = async () => {
    if (!isLogin) {
      return;
    }
    try {
      const res = await API.getTicketDetail({
        act_sign: props.actSign,
        // 根据实际活动标识配置
        module: props.module
      });
      ticketData.value = res;
      variable.data.hasTicket = res.hasTicket ? 1 : 0; // 用户是否领取门票
      // 更新显示内容
      if (res.hasTicket) {
        if (hasSessionTicket.value) {
          //设置fego变量 todo
          buttonText.value = '報名投資策略會';
        } else {
          buttonText.value = '邀好友拎免費門票';
        }
      } else {
        buttonText.value = '免費拎門票';
      }
      if (res.status === 2) {
        // eslint-disable-line  @typescript-eslint/no-magic-numbers
        variable.data.hasChecked = 1;
        hsaChecked.value = true;
      }

      // 更新用户昵称
      if (res.nick) {
        userNickname.value = res.nick;
        variable.data.userNickname = formattedUserNickname.value;
      }
      if (variable.data.sessionTimeText) {
        statusText.value = variable.data.sessionTimeText;
      }
    } catch (error) {
      console.log('error------', error);
      console.error('获取门票详情失败:', error);
      toast.error('加載失敗');
    }
  };
  const handleShareExpoPage = () => {
    emit('share_expo_page');
  };
  const handleSession = () => {
    emit('switch_session');
  };
  /**
   * 报名领取门票 todo暴露方法给父组件
   */
  const handleJoin = throttle(async () => {
    if (!userData.value.uid) {
      toLogin();
      return;
    }

    // 已报名
    if (ticketData.value.hasTicket) {
      return;
    }
    try {
      const res = await API.joinActivity({
        act_sign: props.actSign,
        module: props.module
      });
      if (res.success) {
        toast.success(res.message);
        emit('sign_ticket_success');
        // 刷新门票信息
        await init();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error('报名失败:', error);
      toast.error('報名失敗');
    }
  }, 1000); // eslint-disable-line @typescript-eslint/no-magic-numbers

  onMounted(async () => {
    const verifyUrl = `${props.verifyUrl}?uid=${window._params.uid}`;
    const Qr = await import('qrcode');
    const data = await Qr.toDataURL(verifyUrl, {
      margin: 0,
      scale: 16,
      color: {
        light: '#0000',
        dark: '#000'
      }
    });
    state.verifyUrl = data;
    const timer = setInterval(() => {
      const $root = ticketWrapperRef.value;
      if (!$root) {
        clearInterval(timer);
        return;
      }
      // 判断这个元素是否在body中
      const inBody = document.body.contains($root);
      if (!inBody) {
        clearInterval(timer);
        return;
      }
      if (hsaChecked.value) {
        clearInterval(timer);
        return;
      }
      if (!state.showVerifyModal) {
        return;
      }
      init();
    }, 5000); // eslint-disable-line @typescript-eslint/no-magic-numbers
  });
  onMounted(() => {
    init();
  });
  return Object.assign({
    ticketWrapperRef,
    state,
    props,
    hsaChecked,
    ticketData,
    statusText,
    formattedUserNickname,
    hasSessionTicket,
    hasSessionRemain,
    handleShareExpoPage,
    handleSession,
    handleJoin
  }, {
    claimTicket: () => handleJoin(),
    login: () => toLogin()
  });
};
__sfc_main.components = Object.assign({
  VerifyModal
}, __sfc_main.components);
export default __sfc_main;
</script>

<style scoped lang="less">
/* 外层容器 - 包含门票卡片和按钮 */
.ticket-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.2rem;
}

.ticket-placeholder {
    width: 6.75rem;
    height: 3.11rem;
    display: block;
    margin: 0 auto;
}

/* 门票卡片容器 - Frame 2131032420 - layout_UK8SIZ */
.ticket-container {
    position: relative;
    width: 6.75rem;
    height: 3.03rem;
    overflow: hidden;
    background-image: url('../images/ticket-bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
}

/* 状态文本 - "未报名" - layout_V98R74 */
.status-text {
    position: absolute;
    top: 0.96rem;
    left: 5.14rem;
    width: 1.06rem;
    height: 0.29rem;
    /* style_ZBNX63 */
    font-family: FZLanTingHeiS-DB1-GBK, sans-serif;
    font-weight: 400;
    font-size: 0.2rem;
    line-height: 1.464em;
    letter-spacing: -0.05em;
    /* fill_4YQOGY */
    color: #1f1f1f;
    text-align: left;
}

/* 用户昵称 - "富得流油的富途牛牛" - layout_W98U57 */
.user-nickname {
    position: absolute;
    top: 1.58rem;
    left: 5.19rem;
    width: 1.06rem;
    height: 0.58rem;
    /* style_ZBNX63 */
    font-family: FZLanTingHeiS-DB1-GBK, sans-serif;
    font-weight: 400;
    font-size: 0.2rem;
    line-height: 1.464em;
    letter-spacing: -0.05em;
    /* fill_4YQOGY */
    color: #1f1f1f;
    text-align: left;
    word-break: break-all;
}

/* 时间信息容器 - Frame 2131032421 - layout_3O17W0 */
.time-info-container {
    position: absolute;
    top: 1.52rem;
    left: 0.41rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.38rem;
}

/* 日期文本 - "2026.3.13-3.14" - layout_A76I6M */
.date-text {
    width: 2.12rem;
    /* style_R8SMVI */
    font-family: FZLanTingHeiS-DB1-GBK, sans-serif;
    font-weight: 400;
    font-size: 0.28rem;
    line-height: 1.464em;
    letter-spacing: -0.05em;
    /* fill_4YQOGY */
    color: #1f1f1f;
    text-align: left;
}

/* 时间段文本 - "10:00-18:00" - layout_Q2DLT9 */
.time-text {
    width: 1.82rem;
    /* style_R8SMVI */
    font-family: FZLanTingHeiS-DB1-GBK, sans-serif;
    font-weight: 400;
    font-size: 0.28rem;
    line-height: 1.464em;
    letter-spacing: -0.05em;
    /* fill_4YQOGY */
    color: #1f1f1f;
    text-align: left;
}

/* 领取按钮 - 605:42888 - layout_YXYY45 */
.claim-button {
    position: relative;
    width: 6.7rem;
    height: 1rem;
    /* fill_BLX9M8 */
    background: #ff6900;
    border: none;
    border-radius: 1.18rem;
    cursor: pointer;
    transition: opacity 0.3s;

    &:active {
        opacity: 0.8;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
}

/* 按钮文本 - "免費拎門票" - layout_JY1NGW */
.button-text {
    /* style_QNXFK8 */
    font-family: FZLanTingHeiS-DB1-GBK, sans-serif;
    font-weight: 400;
    font-size: 0.36rem;
    line-height: 1.1445em;
    /* fill_32Z2DS */
    color: #ffffff;
    text-align: center;
    display: block;
}

.ticket-button-container {
    margin: 0 auto;
    width: 6.9rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .claim-button {
        width: 3.4rem;

        &:first-child {
            background: transparent;
            position: relative;
            border: 1px solid #fff;
            box-sizing: border-box;
            &:last-child {
                width: 6.7rem;
            }
        }
    }
}

.ticket-button-container:has(.claim-button:last-child:first-child) {
    justify-content: center;
}
</style>
